import { render, staticRenderFns } from "./CreateConsigne.vue?vue&type=template&id=3ca6a9e2&"
import script from "./CreateConsigne.vue?vue&type=script&lang=ts&"
export * from "./CreateConsigne.vue?vue&type=script&lang=ts&"
import style0 from "./CreateConsigne.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports